import styled from 'styled-components';

const baseFieldCss = `
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4375em;
  letter-spacing: 0.00938em;
  color: rgba(0, 0, 0, 0.87);
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  width: 100%;
  height: 40px;          /* altura padronizada (próxima do MUI) */
  border-radius: 4px;
  padding: 8px 12px;
  border: 1px solid rgba(0,0,0,0.23);
  background-color: #fff;
`;

export const Select = styled.select`
  ${baseFieldCss}
  appearance: none;
`;

export const Input = styled.input`
  ${baseFieldCss}
`;
